const EVENTS = [
  {
    date: "09.08 · 周日",
    label: "本周",
    title: "商界高管深夜发文，全盘否认利益输送",
    note: "回应发出 2 小时后，相关话题阅读破 88 万，评论区两极分化。",
    active: true,
  },
  {
    date: "09.06 · 周五",
    label: "发酵",
    title: "国民级综艺「剪辑事故」登上热搜前三",
    note: "制片方称素材外泄系黑客所为，录制嘉宾同步放出完整录制片段。",
    active: false,
  },
  {
    date: "09.03 · 周二",
    label: "引爆",
    title: "顶流恋情同款照片被扒，热搜 1 小时冲顶",
    note: "从站姐抓拍到行程比对，官方后援会当日深夜宣布「暂时静音」。",
    active: false,
  },
  {
    date: "08.31 · 上上周",
    label: "起底",
    title: "带货一哥旧年直播录像被逐帧重挖",
    note: "一句口误被网友剪成合集，#删评控楼# 顺势成为当日热词。",
    active: false,
  },
];

export default function Timeline() {
  return (
    <section id="timeline" className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-8">
          <div>
            <p className="flex items-center gap-2 text-[13px] font-semibold text-primary-600 tracking-wide">
              <span className="w-1.5 h-3 rounded-sm bg-primary-500" /> TIMELINE
            </p>
            <h2 className="mt-2 font-heading text-[28px] md:text-[36px] font-black text-foreground-950">
              时间线补课<span className="text-primary-500"> · </span>不漏瓜
            </h2>
            <p className="mt-2 text-[14px] text-foreground-500 max-w-[560px]">
              从这周一路倒带回放，把一条热搜从出生到降温的完整脉络串起来。想补课，就沿着时间线往下看。
            </p>

            <div className="mt-8 relative border-l-2 border-primary-100 ml-3 md:ml-4">
              {EVENTS.map((e) => (
                <a key={e.date} href="#recap" className="group relative block pl-6 md:pl-8 pb-8 last:pb-0">
                  <span
                    className={`absolute -left-[9px] top-1.5 w-4 h-4 rounded-full border-2 border-background-50 ${
                      e.active ? "bg-primary-500" : "bg-accent-400 group-hover:bg-accent-500"
                    }`}
                  />
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className={`rounded-full px-2.5 py-0.5 text-[11.5px] font-bold ${e.active ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"}`}>
                      {e.label}
                    </span>
                    <span className="text-[12.5px] text-foreground-400 font-medium">{e.date}</span>
                  </div>
                  <h3 className="text-[17px] md:text-[18px] font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {e.title}
                  </h3>
                  <p className="mt-1.5 text-[13.5px] leading-relaxed text-foreground-500 max-w-[620px]">{e.note}</p>
                </a>
              ))}
            </div>
          </div>

          {/* 补课小贴士 */}
          <div className="lg:sticky lg:top-24 h-fit">
            <div className="bg-accent-500 rounded-lg p-6 text-background-50">
              <span className="inline-flex w-12 h-12 rounded-full bg-background-50/15 items-center justify-center">
                <i className="ri-history-line w-6 h-6 flex items-center justify-center" />
              </span>
              <h3 className="mt-4 font-heading text-[20px] font-black leading-snug">新进圈？从本周开始补最省力</h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-background-50/90">
                时间线默认从「最新」往回排。往下越走越是前情提要，跟着节点走一遍，基本就能接上当下讨论的热点上下文。
              </p>
              <a
                href="#weekly"
                className="mt-5 inline-flex items-center gap-2 rounded-md bg-background-50 text-foreground-900 px-4 py-2.5 text-sm font-bold hover:bg-background-100 whitespace-nowrap"
              >
                回到本周汇总 <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>

            <div className="mt-4 rounded-lg border border-background-200 bg-background-100/60 p-5">
              <h4 className="text-[14px] font-bold text-foreground-900 flex items-center gap-2">
                <i className="ri-information-line w-4 h-4 text-accent-600 flex items-center justify-center" />
                怎么用好这份档案
              </h4>
              <ul className="mt-3 space-y-2 text-[13px] text-foreground-600 leading-relaxed">
                <li className="flex gap-2"><span className="text-primary-500">·</span> 关注自己想补的题材分栏，不必从头翻到尾</li>
                <li className="flex gap-2"><span className="text-primary-500">·</span> 本周汇总看「新」，时间线看「前因后果」</li>
                <li className="flex gap-2"><span className="text-primary-500">·</span> 热度总榜每小时刷新，锚定当下最热的话题</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}